import React, { Component } from 'react';
import Input from '../component/Input.js';
import axios from 'axios';
import {loginPath} from './routes.js';
import Validation from './Validation.js';
import loader from '../asset/img/loader.gif';

export default class RecoverPassword extends Component{
	constructor(props){
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.state = {email:'',validEmail:true,emailSent:false,loading:false, failPrompt:''};
	}

	handleInput(identity,value){ //standard method for handling user input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	onSubmit(){ //method that handles sending the user their account recovery link
		if(Validation("email",this.state.email)){ //validate input field, make sure it is an email address
			this.setState({loading:true});
			axios({
				method:'post',
				url:loginPath,
				headers:{'Content-Type':'application/json'},
				data:{action:'recover',email:this.state.email.toLowerCase()}
			}).then((response)=>{
				let data = response.data.data;
				this.setState({emailSent:true,loading:false, failPrompt: ''});
			}).catch((err) => {
				console.log(err);
				if (!err.response || err.message === 'Network Error') {
					this.setState({
						failPrompt: 'Connection timed out. Please ensure you are on the GF Network.',
						loading: false
					});
				} else {
					this.setState({
						failPrompt:'An error has occured. Please try again later or contact an admin.',
						loading:false
					});
				}
				this.setState({loading:false});
			});
		}else{
			this.setState({
				failPrompt: 'Not a valid email address.',
				validEmail:false
			});
		}
	}

	render(){
		let invalid;
		let inputStyles = "h2 mb2 pl3 br2 bw1 w-100 shadow-3";
		inputStyles = this.state.validEmail ? inputStyles + "  b--light-silver" : inputStyles + "  b--red";
		invalid = <span className="red">{this.state.failPrompt}</span>;
		const labelStyles = "fl w-100 tl b navy f5 mt3";
		const inputDiv = "fl w-100 tl pt2";
		let content;
		if( this.state.loading ){
			content = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else if(!this.state.emailSent){ //display the email input field
			content = <div>
									<div>
										<h1 className="b navy f3 tc pa0 ma0">Recover Account</h1>
									</div>
									<div className={labelStyles}>
										<label>Account Email:<span className="red">*{invalid}</span></label>
									</div>
									<div className={inputDiv}>
										<Input identity="email" inputStyle={inputStyles} onInput={this.handleInput} placeholder="email@georgfischer.com"/>
									</div>
									<div className="fl w-100 tc mt3 mb3">
										<button className="fc w-50-ns w-100 br3 pv2 f5 shadow-3 bg-navy white" onClick={this.onSubmit}>Submit</button>
									</div>
								</div>;
		}else{ //display message
			content = <div><p className="f3 underline tc navy center">Email Sent!</p><p className="b navy f4 tc">You should soon receive an email regarding your account.</p></div>;
		}
		return(
			<div>
				<div style={{maxWidth:'100%',margin:'auto'}}>
					{content}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/RecoverPassword.js